import { setAngularJSGlobal } from '@angular/upgrade/static';
import * as angular from 'angular';
import { environment } from "environments";
import pims from '../../angularJs/src/app/index.module.ajs';

setAngularJSGlobal(angular);

// TODO: [deprecate] angularJS dependency
export function loadConstantsIntoAngularJS() {
  const ngConstants = angular.module('pims.constants', []);
  Object.entries(environment.constants).forEach(([name, value]) =>
    ngConstants.constant(name, value)
  );
  pims.constant('loggerConfig', {
      enabled: true
    })
  console.log(environment.constants);
}
